var unirest = require('unirest');
const API = require ('Api') ;




export async function getTutorCourses ( token , calendarID) {
    const res =  await unirest.get( API.V2   + API.TUTORS + "my-courses" )
    .headers({'Authorization': 'Bearer ' + token, 'crrntcal':calendarID, 'Content-Type': 'application/json'})
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}


export async function getCourseNotebookTool ( token , courseID, toolID) {
    const res =  await unirest.get( API.V2   + API.NOTEBOOKS + "courses/"+courseID+"/"+toolID )
    .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}



// export async function getCourseSubject ( token , courseSubjectID) {
//     const res =  await unirest.get(apiv2 + "teachers/courses/"+courseSubjectID )
//     .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
//     if (res.error) console.log(res.error)
//     let list = res.body ;
// return list ;
// }

// export async function getCourseEvals ( token , courseSubjectID) {
//     const res =  await unirest.get(apiv2 + "subjects/"+courseSubjectID+ "/evals" )
//     .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
//     if (res.error) console.log(res.error)
//     let list = res.body ;
// return list ;
// }

// export async function getCourseSubjectStudentsEvals ( token , courseSubjectID, personaID) {
//     const res =  await unirest.get(apiv2 + "subjects/"+courseSubjectID+"/"+personaID  + "/evals" )
//     .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
//     if (res.error) console.log(res.error)
//     let list = res.body ;
// return list ;
// }

// export async function getCourseSubjectStudents ( token , courseSubjectID) {
//     const res =  await unirest.get(apiv2 + "subjects/"+courseSubjectID+"/students")
//     .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
//     if (res.error) console.log(res.error)
//     let list = res.body ;
// return list ;
// }
// // 

// export async function updateCourseSubjectStudentsEvals ( token, courseSubjectID, personaID, evaluationID, data ) {

//     const res =  await unirest.put(apiv2 + "subjects/"+courseSubjectID+"/"+personaID  + "/evals/"+evaluationID )
//             .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
//             .send(data)
//     if (res.error) console.log(res.error)
//     let list = res.body ;
// return list ;
// }

// export async function addCourseSubjectStudentsEvals ( token, courseSubjectID, personaID, evaluationID, qualifValueID , comments ) {
//     let data =  { qualif_value_id: qualifValueID, comments: comments } ;

//     const res =  await unirest.post(apiv2 + "subjects/"+courseSubjectID+"/"+personaID  + "/evals/" + evaluationID )
//             .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
//             .send(data)
//     if (res.error) console.log(res.error)
//     let list = res.body ;
// return list ;
// }